import { Inject } from '@angular/core';
import templateSource from './view.html';
              import { Component } from '@angular/core';

import Wiz from 'src/wiz';
let wiz = new Wiz('/wiz').app('component.auth.forgot');
import { OnInit, Output, EventEmitter, ChangeDetectorRef as CDR } from '@angular/core';
import { Service } from "src/libs/portal/season/service";

@Component({
    selector: 'wiz-component-auth-forgot',
template: templateSource || '',
    styles: [`

/* file: /mnt/data/wiz/project/main/build/src/app/component.auth.forgot/view.scss */
:host {
  display: block;
}`],
})
export class ComponentAuthForgotComponent implements OnInit {
    @Output() public changeMode = new EventEmitter<string>();

    public step: number = 1;
    public data: any = {
        id: '',
        email: '',
        password: '',
        password_confirm: ''
    };

    constructor(@Inject( Service) public service: Service,@Inject( CDR)  public ref: CDR) { }

    public async ngOnInit() {
        await this.service.render();
    }

    public async verify() {
        if (!this.data.id || !this.data.email) {
            return await this.service.alert.show({ message: '아이디와 이메일을 입력해주세요.', status: 'error', action: '확인' });
        }

        const { code, data } = await wiz.call('verify', { id: this.data.id, email: this.data.email });
        if (code !== 200) {
            return await this.service.alert.show({ message: data, status: 'error', action: '확인' });
        }

        this.step = 2;
        this.ref.detectChanges();
    }

    public async reset() {
        if (!this.data.password || !this.data.password_confirm) {
            return await this.service.alert.show({ message: '비밀번호를 입력해주세요.', status: 'error', action: '확인' });
        }
        if (this.data.password !== this.data.password_confirm) {
            return await this.service.alert.show({ message: '비밀번호가 일치하지 않습니다.', status: 'error', action: '확인' });
        }
        if (this.data.password.length < 4) {
            return await this.service.alert.show({ message: '비밀번호는 최소 4자 이상이어야 합니다.', status: 'error', action: '확인' });
        }

        const user = { ...this.data };
        user.password = this.service.auth.hash(user.password);

        const { code, data } = await wiz.call('reset', user);
        if (code !== 200) {
            return await this.service.alert.show({ message: data, status: 'error', action: '확인' });
        }

        await this.service.alert.show({
            title: '성공',
            message: '비밀번호가 성공적으로 변경되었습니다. 다시 로그인해주세요.',
            status: 'success',
            action: '확인'
        });

        this.gotoLogin();
    }

    public gotoLogin() {
        this.changeMode.emit('login');
    }
}

export default ComponentAuthForgotComponent;